import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { markHydrated } from "@/lib/hydration";

/**
 * `false` on the server render and the first client render, then `true` after
 * mount. Use it to gate a submit button.
 *
 * Pass the same `name` as the page's `<HydrationGuard name="...">` to mark that
 * guard hydrated.
 *
 *   const hydrated = useHydrated("profile");
 *   <Button type="submit" disabled={isSubmitting || !hydrated}>Continue</Button>
 */
export function useHydrated(name) {
  const $ = _c(3);
  const [hydrated, setHydrated] = useState(false);
  let t0;
  let t1;
  if ($[0] !== name) {
    t0 = () => {
      setHydrated(true);
      if (name) {
        markHydrated(name);
      }
    };
    t1 = [name];
    $[0] = name;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return hydrated;
}